import CreateInventoryGroupContent from "../../content/inventoryGroup/createInventoryGroup";
import { Layout } from "../../layout/page";

export function CreateInventoryGroup() {
  return (
    <Layout>
      <CreateInventoryGroupContent />
    </Layout>
  );
}
